import React from "react";

const BreadcrumbsContainer = ({ children, isMobile, settings }) => {
    const { section } = settings || {};
    const alignment = section?.content_alignment || "left";
    
    return (
        <div className={`breadcrumbs-container text-${alignment}`}>
            <nav aria-label="breadcrumb" className="breadcrumb-container">
                <ol
                    className={`breadcrumb flex flex-wrap ${isMobile ? (section?.text_style_mobile || "b4") : (section?.text_style || "b3")}`}
                    itemScope
                    itemType="http://schema.org/BreadcrumbList"
                >
                    {children}
                </ol>
            </nav>
        </div>
    );
};

export default BreadcrumbsContainer;
